/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Box, Divider, Menu, MenuItem, styled, TextField, Typography, useTheme } from '@mui/material';
import useDebounce from '../hooks/useDebounce';
import { Close } from '@mui/icons-material';
import { isOperableArray } from '../helpers/other';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SearchIcon from '@mui/icons-material/Search';
import { useLazyEffect } from '../hooks/useLazyEffect';

const StyledInput = styled(TextField)`
  background: ${(props) => props.theme?.header?.search?.color};
  padding: 8px 20px;
  border: none;
  width: ${(props) => (props.isMultiSearch ? '350px' : '250px')};
  border-radius: 5px;
`;

const StyledDropdown = styled(Box)`
  cursor: pointer;
  background: ${(props) => props.theme?.header?.search?.color};
`;

const SearchDropdown = ({ selected, onChange, options }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();

  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (option) => {
    onChange(option);
    setAnchorEl(null);
  };

  return (
    <>
      <StyledDropdown
        display="flex"
        alignItems="center"
        aria-owns={anchorEl ? 'simple-menu' : undefined}
        aria-haspopup="true"
        onClick={handleClickListItem}
      >
        <Typography noWrap textAlign="center" sx={{ width: '100px' }}>
          {selected?.label || selected?.value}
        </Typography>
        <KeyboardArrowDownIcon />
        <Divider orientation="vertical" sx={{ height: '20px', margin: '0 8px 0 4px' }} />
      </StyledDropdown>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{
          '.MuiMenu-list': {
            background: theme.header.search.color,
            width: '150px',
          },
          '.MuiMenu-paper': {
            marginTop: '16px',
            marginLeft: '-20px',
          },
        }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={index}
            disabled={option.disabled}
            selected={option.value === selected?.value}
            onClick={() => handleMenuItemClick(option)}
          >
            <Typography noWrap sx={{ width: '100px' }}>
              {option.label || option.value}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

const CustomDatatableSearch = ({ onChange, isMultiSearch, searchOptions, value: currentValue = '' }) => {
  const [value, setValue] = useState(currentValue);
  const [selectedOption, setSelectedOption] = useState(isOperableArray(searchOptions) ? searchOptions[0] : null);
  const searchTerm = useDebounce(value, 1000);

  useLazyEffect(() => {
    if (isMultiSearch) onChange(searchTerm, selectedOption);
    else onChange(searchTerm);
  }, [searchTerm]);

  const handleSelection = (option) => {
    setSelectedOption(option);
    setValue('');
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={(theme) => ({
        [theme.breakpoints.down('sm')]: {
          mb: 2,
        },
      })}
    >
      <StyledInput
        onChange={(e) => setValue(e.target.value)}
        value={value}
        placeholder="Search"
        isMultiSearch={isMultiSearch}
        InputProps={{
          disableUnderline: true,
          ...(isMultiSearch &&
            selectedOption && {
              startAdornment: (
                <SearchDropdown selected={selectedOption} onChange={handleSelection} options={searchOptions} />
              ),
            }),
          ...(value
            ? { endAdornment: <Close onClick={() => setValue('')} style={{ cursor: 'pointer' }} /> }
            : { endAdornment: <SearchIcon color="disabled" style={{ cursor: 'pointer' }} /> }),
        }}
        variant="standard"
      />
    </Box>
  );
};

export default CustomDatatableSearch;
